export const SPORTS = {
    Football: ["Gardien", "Défenseur", "Milieu", "Attaquant"],
    Basket: ["Meneur", "Arrière", "Ailier", "Pivot"],
    Handball: ["Gardien", "Ailier", "Arrière", "Pivot"]
  };
  